const STATUS_LABELS = {0: 'INACTIVE', 1: 'ACTIVE', 2: 'LAPSED'};

export const getPolicyStatusLabel = (status) => STATUS_LABELS[status] ?? 'ARCHIVED';

export const getPolicyStatusTone = (status) => {
  if (status === 1) return 'success';
  return getPolicyStatusLabel(status) === 'ARCHIVED' ? 'danger' : 'warning';
};

// Guidance shown next to the status badge; `member` is the policy's MainMember (may be undefined).
export const getPolicyStatusMessage = (member) => {
  if (!member) return null;
  if (member.Status === 0 || member.Status === 2) return 'Make a subscription to enable it';
  if (getPolicyStatusLabel(member.Status) === 'ARCHIVED') return 'Please call our customer service for guidance';
  return null;
};
